<template>
<picture class="w-2/3 object-scale-fill">
    <a href="/"><img :src="isDark ? dark : light"></a>
</picture>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
const store = useStore()

    const props = defineProps({
        light: {
            type: String,
            default: ''
        },
        dark: {
            type: String,
            default: ''
        },
    })

    const isDark = computed(() => store.state.darkMode);


</script>
